import { render, staticRenderFns } from "./StepCardHeader.vue?vue&type=template&id=3da09bdc&scoped=true&"
import script from "./StepCardHeader.vue?vue&type=script&lang=js&"
export * from "./StepCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./StepCardHeader.vue?vue&type=style&index=0&id=3da09bdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da09bdc",
  null
  
)

export default component.exports